import GrinningFace from "@assets/wordpuzzle/grinning-face-with-big-eyes.svg";
import ThinkingFace from "@assets/wordpuzzle/thinking-face.svg";
import { JSX } from "react";

type StatusMessageProps = {
  status: string;
  incorrectCombination: string;
};

function StatusMessage({
  status,
  incorrectCombination,
}: StatusMessageProps): JSX.Element {
  return (
    <>
      {status === "correct" && (
        <div className="flex items-center justify-center flex-row  w-full md:h-14 bg-bg-primary">
          <img
            src={GrinningFace}
            className="w-12 h-12 p-2"
            alt="Status Correct"
          />
          <span className="text-sm text-green-500">Betul!</span>
        </div>
      )}
      {status === "correctNext" && (
        <div className="flex items-center justify-center flex-row  w-full md:h-14 bg-bg-primary">
          <span className="text-sm text-green-500 font-primary">
            Pilih perkataan yang betul
          </span>
        </div>
      )}
      {status === "incorrect" && (
        <div className="flex items-center justify-center flex-row  w-full md:h-14 bg-bg-primary">
          <img
            src={ThinkingFace}
            className="w-12 h-12 p-2"
            alt="Status Incorrect"
          />
          <span className="text-sm">Salah!</span>
          <span className="pl-2 text-sm text-gray-700">
            {incorrectCombination}
          </span>
        </div>
      )}
    </>
  );
}

export default StatusMessage;
